import React from "react";
import style from "./dialog.module.css";

const Dialog = ({
    isOpen,
    title,
    actions = [],
    onClose
}) => {
    if (!isOpen) return null;

    const pageUrl = encodeURIComponent(window.location.href);
    const message = encodeURIComponent("Check this out!");

    const shareLinks = {
        whatsapp: `https://wa.me/?text=${message}%20${pageUrl}`,
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`,
        telegram: `https://t.me/share/url?url=${pageUrl}&text=${message}`,
        twitter: `https://twitter.com/intent/tweet?url=${pageUrl}&text=${message}`
    };

    const copyLink = async () => {
        const text = window.location.href;

        try {
            // Modern API (secure contexts + supported browsers)
            if (navigator.clipboard && window.isSecureContext) {
                await navigator.clipboard.writeText(text);
            } else {
                // Legacy fallback (works on Android/iOS too)
                const textarea = document.createElement("textarea");
                textarea.value = text;
                textarea.style.position = "fixed";   // prevent scroll jump
                textarea.style.left = "-9999px";     // keep it off-screen
                document.body.appendChild(textarea);
                textarea.focus();
                textarea.select();
                document.execCommand("copy");
                document.body.removeChild(textarea);
            }
        } catch (err) {
            console.error("Copy failed:", err);
        }
    };

    const continueShare = (app) => {
        switch (app) {
            case 1: // WhatsApp
                window.open(shareLinks.whatsapp, "_blank");
                break;
            case 2: // Facebook
                window.open(shareLinks.facebook, "_blank");
                break;
            case 3: // Telegram
                window.open(shareLinks.telegram, "_blank");
                break;
            case 4: // Twitter / X
                window.open(shareLinks.twitter, "_blank");
                break;
            case 5: // Copy link
                copyLink();
                break;
            default:
                break;
        }

        onClose();
    };

    return (
        <div
            className={[style.dialogView]}
            onClick={onClose}>
            <div
                className={[style.dialogContents]}
                onClick={(e) => e.stopPropagation()}>

                <div>
                    {title && (
                        <div className={[style.title]}>{title}</div>
                    )}
                </div>

                <div className={style.shareAppsView}>
                    <button onClick={() => continueShare(1)}>
                        <img src={require("../../media/icons/whatsapp_icon.png")} />
                        WhatsApp
                    </button>

                    <button onClick={() => continueShare(2)}>
                        <img src={require("../../media/icons/facebook_icon.png")} />
                        Facebook
                    </button>


                    <button onClick={() => continueShare(3)}>
                        <img src={require("../../media/icons/telegram_icon.png")} />
                        Facebook
                    </button>


                    <button onClick={() => continueShare(4)}>
                        <img src={require("../../media/icons/x_icon.png")} />
                        X.com
                    </button>


                    <button onClick={() => continueShare(5)}>
                        <img src={require("../../media/icons/link_icon.png")} />
                        Copy Link
                    </button>
                </div>

                {/* Action Buttons */}
                <div className={[style.mgT20px]}>
                    {actions.map((action, index) => (
                        <button
                            key={index}
                            className={[style.actionBtn, action.variant == 'positive' ? style.positiveBtn : style.negativeBtn].join(" ")}
                            onClick={action.onClick}
                        >
                            {action.label}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Dialog;